import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './components/App'
import { initializeApiService } from './services/api'

// 引入全局样式
import 'antd/dist/reset.css'
import './assets/global.css'

// 初始化API服务
initializeApiService()

// 创建根元素
const container = document.getElementById('root')

if (!container) {
  console.error('找不到root元素！');
} else {
  console.log('找到root元素，开始渲染应用');
  const root = createRoot(container)

  // 渲染应用
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  )
} 